__turbopack_context__.v({
  "headerBar": "HeaderBar-module-scss-module__HUvyga__headerBar",
  "headerBarWhite__button": "HeaderBar-module-scss-module__HUvyga__headerBarWhite__button",
  "headerBarWhite__iconwrapper": "HeaderBar-module-scss-module__HUvyga__headerBarWhite__iconwrapper",
  "headerBarWhite__order": "HeaderBar-module-scss-module__HUvyga__headerBarWhite__order",
  "headerBarWhite__text": "HeaderBar-module-scss-module__HUvyga__headerBarWhite__text",
  "headerBar__button": "HeaderBar-module-scss-module__HUvyga__headerBar__button",
  "headerBar__heart": "HeaderBar-module-scss-module__HUvyga__headerBar__heart",
  "headerBar__iconwrapper": "HeaderBar-module-scss-module__HUvyga__headerBar__iconwrapper",
  "headerBar__iconwrapper__favor": "HeaderBar-module-scss-module__HUvyga__headerBar__iconwrapper__favor",
  "headerBar__order": "HeaderBar-module-scss-module__HUvyga__headerBar__order",
  "headerBar__select": "HeaderBar-module-scss-module__HUvyga__headerBar__select",
});
